import InputField from "@common/InputRuleFeild";
import { getValue } from "@utils/lodash";

function GlForm(props: any) {
  const { request, setRequest, simpleValidator, handleChangeText } = props;

  return (
    <div className="checkpoint-active-details-wrapper__form-wrapper project-form-wrapper">
      <div className="checkpoint-active-details-wrapper__form-content">
        <div className="user-details-wrapper__form user-details-wrapper__form--org-profile">
          <div className="user-details-wrapper__form-group">
            <label className="checkpoint-active-details__label form-label-error">
              GL Name <span>*</span>
            </label>
            <InputField
              inputType="TEXT"
              placeholder="Enter GL Name"
              className="form-control w-100"
              name="gl_name"
              id="gl_name"
              value={getValue(request, `gl_name`, "")}
              onChange={(e: any) => handleChangeText(e)}
              label="GL Name"
              validator={simpleValidator}
            />
          </div>

          <div className="user-details-wrapper__form-group">
            <label className="checkpoint-active-details__label form-label-error">
              GL Code <span>*</span>
            </label>
            <InputField
              inputType="TEXT"
              placeholder="Enter GL Code"
              className="form-control w-100"
              name="gl_code"
              id="gl_code"
              value={getValue(request, `gl_code`, "")}
              onChange={(e: any) => handleChangeText(e)}
              label="GL Code"
              validator={simpleValidator}
            />
          </div>

          <div className="user-details-wrapper__form-group">
            <label className="checkpoint-active-details__label form-label-error">
              Description <span>*</span>
            </label>
            <InputField
              inputType="TEXTAREA"
              placeholder="Enter Description"
              className="form-control w-100"
              name="description"
              id="description"
              value={getValue(request, `description`, "")}
              onChange={(e: any) => handleChangeText(e)}
              label="Description"
              validator={simpleValidator}
            />
          </div>

       
        </div>
      </div>
    </div>
  );
}

export default GlForm;
